import { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { AdminAPI } from '@guestgoodie/graphql'

import { useAuth } from '@/features/auth'

export function useDeleteUser() {
  const { signOut } = useAuth()
  const [deleteUser, { loading }] = useMutation(AdminAPI.user.DELETE)

  const onDelete = useCallback(() => {
    deleteUser().then(() => signOut())
  }, [deleteUser, signOut])

  return {
    loading,
    onDelete
  }
}
